import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Phone, MessageCircle, Facebook, Instagram, Music } from 'lucide-react';

const Header = () => {
  return (
    <header className="bg-white/95 backdrop-blur-sm border-b border-border sticky top-0 z-50 shadow-soft">
      <div className="container mx-auto px-4">
        {/* Top Bar */}
        <div className="flex items-center justify-between py-2 text-sm border-b border-border/50">
          <div className="flex items-center gap-4">
            <a href="tel:0695523598" className="flex items-center gap-2 text-primary hover:text-primary/80 transition-smooth">
              <Phone className="h-4 w-4" />
              <span className="hidden sm:inline">069 552 3598</span>
            </a>
            <span className="text-muted-foreground hidden md:inline">100 Market Street, Polokwane</span>
          </div>
          <div className="flex items-center gap-3">
            <a href="https://facebook.com/glowbyprecious" target="_blank" rel="noopener noreferrer" 
               className="text-muted-foreground hover:text-primary transition-smooth">
              <Facebook className="h-4 w-4" />
            </a>
            <a href="https://instagram.com/glowbyprecious1" target="_blank" rel="noopener noreferrer"
               className="text-muted-foreground hover:text-primary transition-smooth">
              <Instagram className="h-4 w-4" />
            </a>
            <a href="https://tiktok.com/@glowbyprecious" target="_blank" rel="noopener noreferrer"
               className="text-muted-foreground hover:text-primary transition-smooth">
              <Music className="h-4 w-4" />
            </a>
          </div>
        </div>

        {/* Main Navigation */}
        <div className="flex items-center justify-between py-4">
          <Link to="/" className="flex items-center gap-3">
            <img 
              src="./images/IMG-20251012-WA0003.jpg" 
              alt="Glow by Precious Logo - With Nature's Touch"
              className="h-16 w-auto object-contain"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            <Link to="/" className="text-foreground hover:text-primary transition-smooth font-medium">Home</Link>
            <Link to="/about" className="text-foreground hover:text-primary transition-smooth font-medium">About</Link>
            <Link to="/services" className="text-foreground hover:text-primary transition-smooth font-medium">Services</Link>
            <Link to="/gallery" className="text-foreground hover:text-primary transition-smooth font-medium">Gallery</Link>
            <Link to="/packages" className="text-foreground hover:text-primary transition-smooth font-medium">Packages</Link>
            <Link to="/faq" className="text-foreground hover:text-primary transition-smooth font-medium">FAQ</Link>
            <Link to="/contact" className="text-foreground hover:text-primary transition-smooth font-medium">Contact</Link>
          </nav>

          {/* CTA Buttons */}
          <div className="flex items-center gap-3">
            <a href="https://wa.me/27695523598" target="_blank" rel="noopener noreferrer">
              <Button className="gradient-primary text-white shadow-elegant hover:shadow-lg transition-all duration-300 animate-glow">
                <MessageCircle className="h-4 w-4 mr-2" />
                <span className="hidden sm:inline">WhatsApp</span>
              </Button>
            </a>
            <a href="tel:0695523598">
              <Button variant="outline" className="border-primary text-primary hover:bg-primary hover:text-white transition-smooth">
                <Phone className="h-4 w-4 mr-2" />
                <span className="hidden sm:inline">Call Now</span>
              </Button>
            </a>
          </div>
        </div>

        {/* Mobile Navigation */}
        <nav className="lg:hidden pb-4 border-t border-border/50 pt-4">
          <div className="flex flex-wrap gap-4 justify-center">
            <Link to="/" className="text-sm text-foreground hover:text-primary transition-smooth">Home</Link>
            <Link to="/about" className="text-sm text-foreground hover:text-primary transition-smooth">About</Link>
            <Link to="/services" className="text-sm text-foreground hover:text-primary transition-smooth">Services</Link>
            <Link to="/gallery" className="text-sm text-foreground hover:text-primary transition-smooth">Gallery</Link>
            <Link to="/packages" className="text-sm text-foreground hover:text-primary transition-smooth">Packages</Link>
            <Link to="/faq" className="text-sm text-foreground hover:text-primary transition-smooth">FAQ</Link>
            <Link to="/contact" className="text-sm text-foreground hover:text-primary transition-smooth">Contact</Link>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;